module.exports = __webpack_public_path__ + "static/img/commemorative-plaques-novalloy.e18ec72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/commemorative/commemorative-plaques-novalloy.jpg
// module id = 1037
// module chunks = 0